import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Register from '../view/Register';
import Login from '../view/Login';
import ProtectedRoutes from '../utils/ProtectedRoutes';
import Dashboard from '../view/Dashboard';
import TicketComment from '../view/TicketComment';
import RestrictedDashboard from '../view/RestrictedDashboard';

const appRoutes: React.FC = () => (
  <Switch>
    <Route path="/register" component={Register} />
    <Route path="/login" component={Login} />
    <ProtectedRoutes exact path="/" component={Dashboard} />
    <ProtectedRoutes exact path="/tickets/:id" component={TicketComment} />
    <ProtectedRoutes exact path="/tickets" component={RestrictedDashboard} />
  </Switch>
);

export default appRoutes;
